const elements = document.querySelectorAll(".hiddenY, .hiddenX-left, .hiddenX-right");

const handleScrollAnimation = (entries) => {
  entries.forEach((entry) => {
      if(entry.isIntersecting){
          entry.target.classList.add("fadein-animation")       
      }
  },{threshold: .9})          
};

const observer = new IntersectionObserver(handleScrollAnimation);

elements.forEach(el =>  observer.observe(el));

